import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = ["fill"];
const _hoisted_3 = ["fill"];
import { computed } from 'vue';
import { useStore } from 'vuex';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeSVG',
    setup(__props) {
        const store = useStore();
        const consumerColors = computed(() => store.getters.getConsumerColors);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _cache[0] || (_cache[0] = _createStaticVNode("<mask id=\"mask0_2076_2120\" style=\"mask-type:luminance;\" maskUnits=\"userSpaceOnUse\" x=\"4\" y=\"6\" width=\"16\" height=\"15\"><path d=\"M4.72412 6.32397H19.5721V20.5702H4.72412V6.32397Z\" fill=\"white\"></path></mask><g mask=\"url(#mask0_2076_2120)\"><path d=\"M4.76123 10.5442V18.7067C4.76123 19.7332 5.59348 20.5655 6.61998 20.5655H17.7007C18.7272 20.5655 19.5595 19.7332 19.5595 18.7067V10.5442L12.1602 6.32748L4.76123 10.5442Z\" fill=\"#AFAFAF\"></path></g><path d=\"M19.5595 12.6745L12.1602 8.45698L4.76123 12.6745V10.5442L12.1602 6.32748L19.5595 10.5442V12.6745Z\" fill=\"#AFAFAF\"></path>", 3)),
                _createElementVNode("path", {
                    d: "M4.48563 9.70949C5.23963 9.08924 6.02663 8.51374 6.85463 8.00974C6.93488 7.94299 7.01563 7.87499 7.09613 7.80749V6.18074C7.09613 5.91249 6.87788 5.69449 6.60913 5.69449H4.96063C4.69163 5.69449 4.47363 5.91249 4.47363 6.18074V9.71749L4.48563 9.70949Z",
                    fill: consumerColors.value?.primary_color
                }, null, 8, _hoisted_2),
                _createElementVNode("path", {
                    d: "M21.7748 12.3192C21.5478 12.3192 21.318 12.26 21.1093 12.1355L12.16 6.78449L3.21077 12.1355C2.59552 12.503 1.79752 12.3027 1.42952 11.6867C1.06127 11.071 1.26177 10.2735 1.87752 9.90549L11.4933 4.15599C11.904 3.91049 12.416 3.91049 12.8265 4.15599L22.4425 9.90549C23.0583 10.2735 23.259 11.071 22.8908 11.6867C22.6473 12.0937 22.2168 12.3192 21.7748 12.3192Z",
                    fill: consumerColors.value?.primary_color
                }, null, 8, _hoisted_3)
            ]));
        };
    }
});
